type Props = {
    violations?: Array<string>
}

export const ValidationViolation = ({violations}: Props) => {

    if (violations && violations.length > 0) {
        return <span className={"help-block"}>
                    <span>{violations.map(violation => <>{violation}<br/></>)}</span>
                </span>
    }

    return null
}